import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import cls from './ProfileFloat.module.scss'
import { Button } from 'shared/ui/Button'
import logo from 'shared/assets/images/profile.png'
import React from 'react'
import { IconBadge, IconBadgeTone, ProfileIcon } from 'shared/ui/Icon'

export const ProfileFLoat = (props) => {
    const { closeProfileFloat, onRedirectToProfile, open = true } = props

    return (
        <BottomSheet
            label="Моменты ждут тебя"
            onOpenChange={(open) => !open && closeProfileFloat()}
            open={open}
        >
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon} tone={IconBadgeTone.GRAY}>
                    <ProfileIcon />
                </IconBadge>
            </div>
            <Text
                className={cls.TitleTextFloat}
                size={TextSize.XL}
                align={TextAlign.LEFT}
                weight={TextWeight.BOLD}
            >
                Моменты ждут тебя!
            </Text>
            <Text
                className={cls.TextFloat}
                align={TextAlign.LEFT}
                weight={TextWeight.MED}
            >
                Твои «Хочу» и «Сделано» уже в твоём профиле
            </Text>
            <Button
                onClick={onRedirectToProfile}
                className={cls.FloatButton}
                text={'Осмотреть профиль'}
            />
        </BottomSheet>
    )
}
